//src/componets/website/website.js/
import React from "react";
import { Routes, Route } from "react-router-dom";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar1 from "../Pages/Navbar/Navbar1";
// import NavbarInventory from "../Pages/Navbar/NavbarInventory";
// import About from "../Pages/About/About";
// import Terms from "../Pages/Terms/Terms";
// import Policy from "../Pages/Policy/Policy";
import Login from "../Pages/Login/Login";
import Register from "../Pages/Login/Register"

import ProtectedRoute from "../Route/ProtectedRoute";
// import Task from '../Dashboard/Admin/Task'
// import Sale from '../Dashboard/Admin/Sales'
// import Invoice from '../Dashboard/Admin/Invoice'
// import Proposal from '../Dashboard/Admin/Proposal'
// import ArtworkInventory from '../Dashboard/Admin/ArtworkInventory'
// import Artwork from '../Dashboard/Admin/Artwork'
// import ArtworkById from '../Dashboard/Admin/ArtworkById'

// import ArtworkPriceListByID from '../Dashboard/Admin/ArtworkPriceListByID'
// import ArtworkPriceListInventory from '../Dashboard/Admin/ArtworkPriceListInventory'
// import ArtworkPriceList from '../Dashboard/Admin/ArtworkPriceList'
// import Utility from '../Dashboard/Admin/Artwork'
// import Settings from "../User/Settings";
// import Account from "../User/Account";
// import Profile from "../User/Profile";
// import ForgotPassword from "../Pages/Login/ForgotPassword";
// import Research from "../Dashboard/Admin/Research";
// import Post from "../Dashboard/Admin/Post";
// import Image from "../Dashboard/Admin/Images";
// import Certificate from "../Dashboard/Admin/Certificate";
// import Workshop from "../Dashboard/Admin/Workshop";
// // import Budget from "../Dashboard/Admin/Budget";
// import ArtistDashboard from "../Dashboard/ArtistDashboard";
import AdminDashboard from "../Dashboard/AdminDashboard";
// import CustomerDashboard from "../Dashboard/CustomerDashboard";
// import TeamDashboard from "../Dashboard/TeamDashboard";
// import CollaboratorDashboard from "../Dashboard/CollaboratorDashboard";
// import UserDashboard from "../Dashboard/User";
import { ROLES } from '../roles'; 
// import Unauthorized from '../Dashboard/Unauthorised';
// import ArtDashboard from "../Dashboard/ArtDashboard";

const InventoryApp = ({ userRole }) => {
  return (
    <>
      {/* <NavbarInventory /> */}
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Login />} />
        {/* <Route path="/About" index element={<About />} /> */}
        {/* <Route path="/Terms" element={<Terms />} /> */}
        {/* <Route path="/Policy" element={<Policy />} /> */}
        <Route path="/register" element={<Register />} />
        {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        {/* <Route path="/unauthorized" element={<Unauthorized />} /> */}

        {/* PROTECTED  */}
        {/* <Route element={<ProtectedRoute allowedRoles={[ROLES.ADMIN]} userRole={userRole} />}>
          <Route path="/dashboard/admin" element={<AdminDashboard />} />
        </Route> */}
        {/* <Route path="/settings" element={<Settings />} /> */}
        {/* <Route path="/account" element={<Account />} /> */}
        {/* <Route path="/profile" element={<Profile />} /> */}
        <Route element={<ProtectedRoute allowedRoles={[ROLES.ADMIN]} userRole={userRole} />}>
          <Route path="/dashboard/admin" element={<AdminDashboard />} />
          {/* <Route path="/dashboard/admin/task" element={<Task />} /> */}
          {/* <Route path="/artwork" element={<Artwork />} /> */}

        </Route>
{/* 
        <Route element={<ProtectedRoute allowedRoles={[ROLES.ARTIST]} userRole={userRole} />}>
          <Route path="/dashboard/artist/dashboard" element={<ArtistDashboard />} />
          <Route path="/dashboard/artist/task" element={<Task />} />
          <Route path="/dashboard/artist/artworkinventory" element={<ArtworkInventory/>} />
          <Route path="/dashboard/artwork/:id" element={<ArtworkById />} />
          <Route path="/dashboard/artist/artwork" element={<Artwork/>} />
          <Route path="/dashboard/artist/artwork/:id/edit" element={<ArtworkPriceList/>} /> */}

          {/* <Route path="/dashboard/artist/artworkPricelistInventory" element={<ArtworkPriceListInventory/>} /> */}
          {/* <Route path="/dashboard/artist/:artworkId/price" element={<ArtworkPriceListByID/>} />
          <Route path="/dashboard/artist/artworkPriceList" element={<ArtworkPriceList/>} />
          <Route path="/profile" element={<Profile />} />

        </Route> */}

        {/* <Route element={<ProtectedRoute allowedRoles={[ROLES.USER]} userRole={userRole} />}>
          <Route path="/dashboard/user" element={<UserDashboard />} />
        </Route>

        

        <Route element={<ProtectedRoute allowedRoles={[ROLES.COLLECTOR]} userRole={userRole} />}>
          <Route path="/dashboard/customer" element={<CustomerDashboard />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[ROLES.TEAM]} userRole={userRole} />}>
          <Route path="/dashboard/team" element={<TeamDashboard />} />
          <Route path="/dashboard/team/task" element={<Task />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[ROLES.COLLABORATOR]} userRole={userRole} />}>
          <Route path="/dashboard/collaborator" element={<CollaboratorDashboard />} />
        </Route> */}
   
        
      </Routes>
    </ >
  );
}

export default InventoryApp;
